import React, { useState,useEffect,useContext } from 'react';
import { Form, Button } from 'react-bootstrap';
import PopUp from '../../components/UIElements/PopUp';
import ErrorPopup from '../../components/UIElements/ErrorPopup';
import axios from 'axios';
import { ToastContainer, Zoom } from 'react-toastify';
import Header from '../../components/Header/Header';
import './ReportIssue.css';
import {Row, Col, Container} from 'react-bootstrap';

function ReportIssue()  {

	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [description, setDescription] = useState('');
	const [category, setCategory] = useState('');
	const [attachments, setFiles] = useState([]);
	const [subject, setSubject] = useState('');
	const [attachmentsName, setAttachmentsName] = useState([]);

	const selectFiles = (event) => {
		const value = event.target.files;
		setFiles({ ...attachments, value});
		let allAttachNames = "";
		for (const key of Object.keys(value)) {
			let name = value[key].name;
			if(name != ""){
				allAttachNames = allAttachNames + "   " +name;
			}			
		}
		setAttachmentsName(allAttachNames);
	}

	const reset = () => {
		setFirstName('');
		setLastName('');
		setEmail('');
		setDescription('');
		setCategory('');
		setSubject('');
		setAttachmentsName([]);
	}


	const handleSubmit = (event) => {
		event.preventDefault();
		const formData = new FormData();
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
		formData.append('email', email);
		formData.append('subject', subject);
		formData.append('description', description);

		if(typeof attachments.value !== 'undefined'){
			for (const key of Object.keys(attachments.value)) {
				formData.append('attachments', attachments.value[key]);
			}			
		}
		
		axios.post(`${process.env.REACT_APP_MAIL_URL}/send`, formData, {
		//axios.post(`http://localhost:8072/mail/api/v1/send`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		}).then((response) => {
			//console.log(response);
			PopUp('Issue reported successfully');				
		}).catch((err) => {
			//console.log(response);
			if (err.response) {
				ErrorPopup(err.response.data.message);						
			} else {
				ErrorPopup('Request failed');				
			}		
		});

		event.target.reset();
		reset();
	};

	return (
		<>
        <Header />
		<Container> 
			<Row>
				<Col sm></Col>
				<Col sm>
				<Form onSubmit={handleSubmit}> 
					<Row>
						<Col>
							<Form.Group controlId="firstName">
								<Form.Label>First Name</Form.Label>
								<Form.Control
									name="firstName"	
									onChange={(e) => setFirstName(e.target.value)}										
									type="text"
									placeholder="Enter first name"
									value={firstName}
									required
								/>
							</Form.Group>
						</Col>
						<Col>
							<Form.Group controlId="lastName">
								<Form.Label>Last Name</Form.Label>
								<Form.Control
									name="lastName"		
									onChange={(e) => setLastName(e.target.value)}									
									type="text"
									placeholder="Enter last name"
									value={lastName}
									required
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col>
							<Form.Group controlId="email">
								<Form.Label>Email Address</Form.Label>
								<Form.Control
									name="email"
									onChange={(e) => setEmail(e.target.value)}									
									type="email"
									placeholder="Enter email address"
									value={email}
									required
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col>
							<Form.Group controlId="category">
								<Form.Label>Category</Form.Label>
								<Form.Control
									as="select"                                           
									name="category"
									value={category}
									onChange={(e) => {
										setCategory(e.target.value);
										setSubject(
											"[ ## UMBRELLA Issue Report ## ] – Category: " + e.target.value);
									}}
									required
									>
									<option value="">Select Category</option>
									<option value="Node">Node</option>
									<option value="Radio">Radio</option>
									<option value="Sensor">Sensor</option>
									<option value="Experiment">Experiment</option>
									<option value="Portal upload / download">Portal upload / download</option>
									<option value="Login">Login</option>
									<option value="Useability">Useability</option>
									<option value="Other">Other</option>
								</Form.Control>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col>
							<Form.Group controlId="subject" className="subject">
								<Form.Label>Subject</Form.Label>
								<Form.Control
									name="subject"																	
									type="text"
									value={subject}
									onChange={(e)=> setSubject(e.target.value)}
									required																		
								/>
							</Form.Group>	
						</Col>
					</Row>	
					<Row>
						<Col>																			
							<Form.Group controlId="description">
								<Form.Label>Description</Form.Label>
								<Form.Control
									name="description"	
									onChange={(e) => setDescription(e.target.value)}								
									as="textarea"
									rows="4"
									placeholder="Enter issue description"
									value={description}
									required/>
							</Form.Group>	
						</Col>
					</Row>
					<Row>
						<Col>
							<Form.Group controlId="attachments" multiple>
								<Form.Label>Attachments<code>(select images files(png, jpg, jpeg))</code></Form.Label>
								<Form.Control 
										name="attachments"
										onChange={selectFiles}
										type="file"							
										multiple />
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col>					
							<Form.Group controlId="attachmentsName">								
								<Form.Control 
										name="attachmentsName"
										as="textarea"
										rows="3"
										value={attachmentsName}
										disabled />
							</Form.Group>
						</Col>
					</Row>	
					<Row>
						<Col>
							<Button className="btnDefault" type="submit">
								Report Issue
							</Button>	
						</Col>					
					</Row>
				</Form>	
				</Col>
				<Col sm></Col>
			</Row>	
		</Container>
		<ToastContainer draggable={false} transition={Zoom} />
		</>
	);
}

export default ReportIssue;